<template>
  <!-- 区域管理 -->
  <div class="treeBigBox app-container">
    <!--树形结构-->
    <div class="treeBox" ref="treeRef">
      <el-tree :data="datatree"
               :props="defaultProps"
               node-key="id"
               :highlight-current="true"

               @node-click="handleNodeClick">
      </el-tree>
    </div>
    <div class="right">
      <div class="right-top">
        <div class="right-top-title">
          <div>
            <h2 ref="shangjiName">{{shangjiName}}</h2>
           <!-- <div style="display: none;">-->
              <span ref="fatherId">{{fatherId}}</span>
            <!--</div>-->
          </div>
          <div class="right-top-btn">
            <el-button type="primary" size="medium" btnCode="00AP001B001"  v-if="btnFlg[0]" @click="addRegion">新增</el-button>
            <el-button type="primary" size="medium" btnCode="00AP001B002"  v-if="btnFlg[1]" @click="modifyRegion">修改</el-button>
          </div>
        </div>
        <div class="table" :style="{height:h}">
          <el-table
            :data="tableData"
            ref="table"
            bordersize="mini"
            height="100%"
            highlight-current-row
            filter-multiple="true"
            style="width: 100%"
            @row-click="handleRowClick"
            center>
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column prop="" type="index" label="序号" width="60" align="center">
            </el-table-column>
            <el-table-column prop="" label="操作" min-width="180"  align="center">
              <template slot-scope="scope">
                <div>
                <el-button type="text" size="mini" @click="suspension(scope.row)" btnCode="00AP001B003"  v-if="scope.row.stateFlg=='1'&&btnFlg[2]">启用</el-button>
                <el-button type="text" size="mini" @click="suspension(scope.row)" btnCode="00AP001B004" v-if="scope.row.stateFlg=='0'&&btnFlg[3]">停用</el-button>
                <el-button type="text" size="mini" @click="cancellation(scope.row)" btnCode="00AP001B005" v-if="scope.row.stateFlg=='1'&&btnFlg[4]" >删除</el-button>
                <el-button type="text" size="mini" @click="jumpDevice(scope.row)" btnCode="00AP001B006" v-if="scope.row.stateFlg=='0'&&btnFlg[5]">查看设备</el-button>
              </div>
              </template>
            </el-table-column>
            <el-table-column prop="regionName" label="名称" min-width="120"  align="center">
            </el-table-column>
            <el-table-column prop="createUserName" label="创建人" min-width="120" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间"  :formatter="dateFormat" min-width="180" align="center">
            </el-table-column>
            <el-table-column prop="tenantName" label="租户名称" min-width="190" align="center">
            </el-table-column>
            <el-table-column prop="stateFlg" label="状态" min-width="100" align="center">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.stateFlg=='0'">
                      启用
                  </span>
                <span v-if="scope.row.stateFlg=='1'">
                    停用
                  </span>
                  </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <!-- 分页 10,25,50,100-->
        <!--<div>
          <el-pagination background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[5,10,25,50,100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>-->
      </div>
    </div>
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               width="400px"
               center>
      <span>
         <el-form  :model="addFrom" :rules="rules" ref="addFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class="">
             <el-form-item label="区域名称:" prop="regionName">
                <el-input  maxlength="10" :validate-event = "false" placeholder=""   v-model.trim="addFrom.regionName"></el-input>
             </el-form-item>
             <!-- <el-form-item label="上级区域id:" prop="pid">
                <el-input  placeholder=""   v-model.trim="addFrom.pid" readonly="readonly" style="border:0px;"></el-input>
              </el-form-item>-->
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="baoCunClick('addFrom')" :loading="addLoad">保 存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getTreeList, addRegion, updateRegion, regionSuspension, deleteRegion, getRegionById } from '@/api/video'
export default {
  inject: ['reload'],

  data () {
    return {
      datatree: [],
      defaultProps: {
        children: 'children',
        label: 'regionName'
      },
      addLoad: false,
      tableData: [],
      dialogVisible: false,
      shangjiName: '',
      fatherId: '',
      h: '500px',
      title: '新建',
      checkList: [],
      tableList: [],
      loading: 'false',
      ids: [],
      rules: {
        regionName: [
          { required: true, message: '请输入区域', trigger: 'blur' }
        ]
      },
      addFrom: {
        pid: '',
        regionName: ''
      },
      btnFlg: [],
      btnIdArr: ['00AP001B001', '00AP001B002', '00AP001B003',
        '00AP001B004', '00AP001B005', '00AP001B006']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/Mregional')
    this.getListTree()
  },
  mounted () {
    /* let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px' */
  },
  methods: {
    getListTree () {
      this.datatree = []
      getTreeList().then(res => {
        this.datatree = res
        if (res[0].pid == 0) {
          this.handleNodeClick(res)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 点击树型结构
    handleNodeClick (data, e) {
      console.log(data)
      if (data instanceof Array) { // 是否为数组\
        this.tableData = data
        // eslint-disable-next-line no-undef
        this.shangjiName = item.regionName
        // eslint-disable-next-line no-undef
        this.fatherId = item.id
      }
      this.tableData = data.children
      this.shangjiName = data.regionName
      this.fatherId = data.id
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList()
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },

    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getGoodsList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getGoodsList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.addFrom.shangjiName = this.$refs.shangjiName.innerHTML
      /* if (this.addFrom.shangjiName == '') {
        this.$alert('请选择上级库区', '系统提示')
        return
      } */
      this.title = '新建'
      this.addFrom = {}
      this.addFrom.pid = this.$refs.fatherId.innerHTML
      this.dialogVisible = true
      this.isAdd = true
    },
    // 添加保存
    baoCunClick (addFrom) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          this.addLoad = true
          if (this.isAdd) {
            addRegion(this.addFrom).then(res => {
              this.$message.success('操作成功')
              this.addLoad = false
              this.dialogVisible = false
              this.getListTree()
              this.reload()
            }).catch(error => {
              this.$message.error(error.message)
              this.addLoad = false
            })
          } else { // 修改
            updateRegion(this.addFrom).then(res => {
              this.$message.success('操作成功')
              this.addLoad = false
              this.dialogVisible = false
              this.getListTree()
              this.reload()
            }).catch(error => {
              this.$message.error(error.message)
              this.addLoad = false
            })
          }
        } else {
          return false
        }
      })
    },
    // 修改
    modifyRegion () {
      this.addFrom.shangjiName = this.$refs.shangjiName.innerHTML
      if (this.addFrom.shangjiName == '') {
        this.$alert('请选择上级库区', '系统提示')
        return
      }
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
        return
      }
      this.title = '修改'
      this.addFrom = {}
      this.addFrom.pid = this.$refs.fatherId.innerHTML
      this.dialogVisible = true
      this.addFrom = JSON.parse(JSON.stringify(selectData[selectData.length - 1]))

      this.isAdd = false
    },
    // 停用/启用
    suspension (row) {
      this.$confirm('是否执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        regionSuspension({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getListTree()
          this.reload()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    cancellation (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'

      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        // 查询此区域下是否有子菜单 ，如果有的话不允许删除
        getRegionById({ id: row.id }).then(res => {
          loading.close()
          if (res.length > 0) {
            this.$alert('此区域下有子区域或子设备，不能删除', '')
            return false
          } else {
            deleteRegion({ id: row.id }).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getListTree()
              this.reload()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      })
    },
    // 点击查看设备
    jumpDevice (row) {
      this.$router.push({
        path: '/device',
        name: 'device',
        query: { regionId: row.id, regionName: row.regionName }
      })
    },
    closeDialog () {
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
  .treeBigBox {
    width: 100%;
    height: calc(100vh - 42px - 35px - 42px);
    // margin-top: -20px;
    display: flex;
  }
  .treeBox {
    width: 25%;
    height: 100%;
    // padding: 20px 0 0 20px;
  }
  .right {
    width: 75%;
    height: 100%;
    border-left: solid 1px #ccc;
  }
  .right-top-title {
    height: 65px;
    margin: 20px 0 0 40px;
    display: flex;
  }
  .right-top-btn {
    line-height: 65px;
    margin-left: 40px;
  }
  .right-top-btn .el-button {
    margin-right: 20px;
  }
  .xiangQingBox {
    margin-top: 50px;
    margin-left: 60px;
  }
  .addinpBox {
    width: 60%;
    margin: 0 auto;
  }
  .addinpBox .el-input {
    width: 210px;
  }

  .demo-form-inline .el-form-item {
    margin-bottom: 17px !important;
  }

  .searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
